"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tracker = void 0;
var _browser = require("@sentry/browser");
const Tracker = exports.Tracker = {
  init: (config, versions, options = {}) => {
    (0, _browser.init)({
      dsn: config.trackerDSN,
      ...options
    });
    (0, _browser.configureScope)(scope => {
      scope.setExtra('config', config);
      scope.setExtra('version', versions.release);
      scope.setExtra('4ff-lib-foundation', versions.foundation);
    });
  },
  captureException: _browser.captureException
};